import { FC, ReactElement } from 'react';

import { Wrapper } from '../../components';
import { Accordion } from '../../compositions';
import { Navigation } from '../../entities/@navigation/Navigation/Navigation';
import { useDeviceWidth } from '../../hooks';
import { FooterSkeletons } from './skeletons';
import { FooterBottom, FooterNavigationGroup } from './subcomponents';

import './Footer.scss';

interface FooterProps {
    isLoading?: boolean;
    showTopFooter?: boolean;
    navigation?: Navigation;
    socialNavigation?: Navigation;
    className?: string;
}

export const Footer: FC<FooterProps> = ({
    isLoading,
    showTopFooter,
    navigation,
    socialNavigation,
    className = '',
}): ReactElement => {
    const { isTabletLandscape, isDesktop } = useDeviceWidth();

    const isBigScreen = isTabletLandscape || isDesktop;

    if (isLoading || !navigation) {
        return (
            <footer className={`footer ${className}`}>
                <FooterSkeletons />

                <FooterBottom />
            </footer>
        );
    }

    const navigationGroups = navigation.groups[0]
        ? navigation.groups[0].items
        : [];

    return (
        <footer className={`footer ${className}`}>
            {showTopFooter && (
                <Wrapper className="footer__wrapper">
                    {navigationGroups.map(navigationGroup => (
                        isBigScreen ? (
                            <FooterNavigationGroup
                                key={navigationGroup.id}
                                hideHeader
                                label={navigationGroup.label}
                                groups={navigationGroup.subNavigation?.groups || []}
                            />
                        ) : (
                            <Accordion
                                key={navigationGroup.id}
                                hasBorder
                                heading={navigationGroup.label}
                                className="footer__accordion-title"
                                headingClassName="footer__accordion-heading"
                                contentClassName="footer__accordion-content"
                            >
                                <FooterNavigationGroup
                                    label={navigationGroup.label}
                                    groups={navigationGroup.subNavigation?.groups || []}
                                />
                            </Accordion>
                        )
                    ))}

                    {socialNavigation && (
                        <FooterNavigationGroup
                            layoutIsRow
                            hideHeader={isBigScreen}
                            label={socialNavigation.title}
                            groups={socialNavigation.groups}
                            className="footer__socials-icons"
                        />
                    )}
                </Wrapper>
            )}

            <FooterBottom />
        </footer>
    );
};
